/**
 * Asking the browser to keep the local store (decision 3: the app calls `navigator.storage.persist()` at first
 * launch). Part 06 log, table P. The app calls it on every launch until it is granted: a browser that said no
 * may say yes later (Chromium grants by engagement), and asking again when already granted is skipped (P2).
 */

/** The part of `navigator.storage` this uses; either method may be missing (P3). */
export interface StorageManagerLike {
  readonly persisted?: () => Promise<boolean>;
  readonly persist?: () => Promise<boolean>;
}

/**
 * `persisted`: already kept (P2); `granted` or `denied`: the answer to asking (P1, P4); `unsupported`: the browser
 * can't be asked (P3).
 */
export type Persistence = 'persisted' | 'granted' | 'denied' | 'unsupported';

/** Asks for persistent storage unless it is already granted (table P). Never rejects. */
export async function requestPersistence(storage: StorageManagerLike | undefined): Promise<Persistence> {
  const persisted = storage?.persisted;
  const persist = storage?.persist;
  if (persisted === undefined || persist === undefined) return 'unsupported';
  try {
    if (await persisted.call(storage)) return 'persisted';
    return (await persist.call(storage)) ? 'granted' : 'denied';
  } catch {
    return 'denied';
  }
}
